import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import { getFormZonasAfectadas } from "../../../../../actions/forms";
import FormikAutocomplete from "../../../../commons/formik/formikAutocomplete";


const ZonaAfectadaControl = ({ disabled, updateFilteredNaturalezasLesion, zonasAfectadas, required, artId, callBack, newZonaAfectadaValue, ...props }) => {
  const { values, setFieldValue } = useFormikContext();
  const dispatch = useDispatch();
  return (
    <FormikAutocomplete
      name="zonaAfectada"
      label={`Zona Afectada ${required ? "*" : ""
        }`}
      variant="outlined"
      callBack={(value) => {
        let newNatualezasLesionOptions = updateFilteredNaturalezasLesion(values.diagnosticoOMS, value?.id);
        if (!newNatualezasLesionOptions.some((naturaleza) => naturaleza.id === values.naturalezaLesion)) {
          setFieldValue('naturalezaLesion', null);
        }
        if (callBack) callBack(value);
      }}
      getOptions={() => dispatch(getFormZonasAfectadas(artId))}
      options={zonasAfectadas}
      disabled={disabled}
      {...props}
    />
  )
}

export default ZonaAfectadaControl;